/**
 * Displays standings for a game
 */
import React from "react";
import GameEvent from "./GameEvent";
import GameRoster from "./GameRoster";
import { useParams } from "react-router-dom";
import GameFeaturedPlayers from "./GameFeaturedPlayers";
import GamePreviewStandings from "./GamePreviewStandings";
import GameLineup from "./GameLineup";

const processPreviewData = (jsonData, game_data) => {
  return jsonData;
};

const GamePreview = (game_data) => {
  const { gameId } = useParams();

  let data2 = game_data.data;

  return (
    <>
      {data2.division.is_cup && (
        <>
          <GamePreviewStandings data={data2} />
        </>
      )}

      <GameEvent eventName={"Who to Watch"} title={true} />
      <GameFeaturedPlayers data={data2} />

        <GameEvent eventName={"Pre-Game Statistics"} title={true} />
        <div className="flex flex-col sm:flex-row justify-between items-start w-full pt-1">
            <GameLineup data={data2} team={"home"} />
            <GameLineup data={data2} team={"away"} />
        </div>

        <GameEvent eventName={"Pre-Game Statistics"} title={true} />
        <div className="flex flex-col sm:flex-row justify-between items-start w-full pt-1">
            <GameRoster data={data2} team={"home"} />
            <GameRoster data={data2} team={"away"} />
        </div>
    </>
  );
};
export default GamePreview;
